<aside class="rail" [class.collapsed]="collapsed()" data-testid="shell-rail">
  <div class="rail-logo">
    <img src="/assets/images/propeller_logo_white.png" [alt]="'common.alt.propeller_logo' | translate" />
  </div>

  <!-- Until the role claim resolves the tree stays EMPTY — no skeleton (r4).
       The rail is not fetched content: it is a static tree waiting to learn
       which items this user may see, so a placeholder would promise rows that
       are already known, invite clicks on nothing, and — worst — the partial
       tree it replaced moved under the cursor as gated sections landed. -->
  <nav class="rail-nav" [class.nbo-reveal]="navReady()">
    @if (navReady()) {
      @for (world of visibleWorlds(); track world.key; let worldIndex = $index) {
      <div class="rail-world">
        @if (collapsed()) {
          @if (worldIndex > 0) {
            <div class="rail-world-divider"></div>
          }
        } @else {
          <div class="rail-world-caption">{{ world.labelKey | translate }}</div>
        }

        @for (section of world.sections; track section.key) {
          @if (collapsed()) {
            <!-- Collapsed 56px rail: icon per section; dark flyout for multi-item
                 sections, tooltip for single-item ones. The active SECTION icon
                 carries the wash here — the item row isn't visible. -->
            <div
              class="rail-icon-cell"
              (mouseenter)="showFlyout(section)"
              (mouseleave)="hideFlyout(section)"
              (focusin)="showFlyout(section)"
              (focusout)="hideFlyout(section)"
            >
              @if (section.items.length <= 1) {
                <a
                  class="rail-icon-btn"
                  [class.active]="isSectionActive(section)"
                  [routerLink]="section.items[0].path"
                  [queryParams]="queryParamsFor(section.items[0])"
                  (click)="trackMenuClick(section.items[0].value)"
                  [matTooltip]="navSectionTranslations[section.key] | translate"
                  matTooltipPosition="right"
                  [attr.data-testid]="'rail-section-' + section.key"
                >
                  <mat-icon>{{ section.icon }}</mat-icon>
                </a>
              } @else {
                <button
                  type="button"
                  class="rail-icon-btn"
                  [class.active]="isSectionActive(section)"
                  [class.flyout-open]="flyoutSection() === section.key"
                  [attr.aria-haspopup]="true"
                  [attr.aria-expanded]="flyoutSection() === section.key"
                  [attr.aria-label]="navSectionTranslations[section.key] | translate"
                  [attr.data-testid]="'rail-section-' + section.key"
                >
                  <mat-icon>{{ section.icon }}</mat-icon>
                </button>
                @if (flyoutSection() === section.key) {
                  <div class="rail-flyout" data-testid="rail-flyout">
                    <div class="rail-flyout-caption">{{ navSectionTranslations[section.key] | translate }}</div>
                    @for (item of section.items; track item.value) {
                      <a
                        class="rail-flyout-row"
                        [class.active]="isItemActive(item)"
                        [routerLink]="item.path"
                        [queryParams]="queryParamsFor(item)"
                        (click)="trackMenuClick(item.value); closeFlyout()"
                        [attr.data-testid]="item.value"
                      >
                        {{ navValueTranslations[item.value] | translate }}
                      </a>
                    }
                  </div>
                }
              }
            </div>
          } @else {
            <!-- Expanded rail: accordion section. Single-item sections are plain
                 chevron-less link rows; the wash marks ONLY the active item row —
                 open/closed-active headers get a strong label, never a wash. -->
            @if (section.items.length <= 1) {
              <a
                class="rail-row"
                [class.active]="isItemActive(section.items[0])"
                [routerLink]="section.items[0].path"
                [queryParams]="queryParamsFor(section.items[0])"
                (click)="trackMenuClick(section.items[0].value)"
                [attr.data-testid]="'rail-section-' + section.key"
              >
                <mat-icon>{{ section.icon }}</mat-icon>
                <span class="rail-row-label">{{ navSectionTranslations[section.key] | translate }}</span>
              </a>
            } @else {
              <button
                type="button"
                class="rail-row"
                [class.strong]="isOpen(section) || isSectionActive(section)"
                (click)="toggleSection(section)"
                [attr.aria-expanded]="isOpen(section)"
                [attr.data-testid]="'rail-section-' + section.key"
              >
                <mat-icon>{{ section.icon }}</mat-icon>
                <span class="rail-row-label">{{ navSectionTranslations[section.key] | translate }}</span>
                <mat-icon class="rail-chevron">{{ isOpen(section) ? 'expand_more' : 'chevron_right' }}</mat-icon>
              </button>
              @if (isOpen(section)) {
                <div class="rail-accordion-panel">
                  @for (item of section.items; track item.value) {
                    <a
                      class="rail-item"
                      [class.active]="isItemActive(item)"
                      [routerLink]="item.path"
                      [queryParams]="queryParamsFor(item)"
                      (click)="trackMenuClick(item.value)"
                      [attr.data-testid]="item.value"
                    >
                      {{ navValueTranslations[item.value] | translate }}
                    </a>
                  }
                </div>
              }
            }
          }
        }
        </div>
      }
    }
  </nav>

  <!-- Rail foot — the collapse toggle lives HERE (top-bar-left was rejected:
       it reads as browser Back). -->
  <div class="rail-foot">
    <button
      type="button"
      class="rail-foot-btn"
      (click)="toggleCollapse()"
      [matTooltip]="(collapsed() ? 'nav.toggle_menu_expand' : 'nav.toggle_menu_collapse') | translate"
      matTooltipPosition="right"
      [attr.aria-label]="(collapsed() ? 'nav.toggle_menu_expand' : 'nav.toggle_menu_collapse') | translate"
      data-testid="rail-collapse-btn"
    >
      <mat-icon>{{ collapsed() ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</mat-icon>
    </button>
  </div>
</aside>
